module.exports = __webpack_public_path__ + "img/co-branding-world-RP-background-5.7db476d6.png";